
(function() {
  var result = { translations: { "nl": { "SharedI18nStrings": { "languageNames": { "af": "Afrikaans", "sq": "Albanees", "sq-al": "Albanees - Albani\xEB", "ar": "Arabisch", "ar-dz": "Arabisch - Algerije", "ar-bh": "Arabisch - Bahrein", "ar-eg": "Arabisch - Egypte", "ar-iq": "Arabisch - Irak", "ar-jo": "Arabisch - Jordani\xEB", "ar-kw": "Arabisch - Koeweit", "ar-lb": "Arabisch - Libanon", "ar-ly": "Arabisch - Libi\xEB", "ar-ma": "Arabisch - Marokko", "ar-om": "Arabisch - Oman", "ar-qa": "Arabisch - Qatar", "ar-sa": "Arabisch - Saoedi-Arabi\xEB", "ar-sd": "Arabisch - Soedan", "ar-sy": "Arabisch - Syri\xEB", "ar-tn": "Arabisch - Tunesi\xEB", "ar-ae": "Arabisch - Verenigde Arabische Emiraten", "ar-ye": "Arabisch - Jemen", "as": "Assamees", "az": "Azerbeidzjaans", "hy": "Armeens", "eu": "Baskisch", "be": "Wit-Russisch", "be-by": "Wit-Russisch - Wit-Rusland", "bn": "Bengali", "bg": "Bulgaars", "bg-bg": "Bulgaars - Bulgarije", "bs": "Bosnisch", "ca": "Catalaans", "ca-es": "Catalaans - Catalaans", "zh": "Chinees", "zh-cn": "Chinees - Vereenvoudigd", "zh-hk": "Chinees - Hong Kong", "zh-mo": "Chinees - Macau", "zh-sg": "Chinees - Singapore", "zh-tw": "Chinees - Traditioneel", "zh-chs": "Chinees (Vereenvoudigd)", "zh-cht": "Chinees (Traditioneel)", "zh-hans": "Chinees (vereenvoudigd Han)", "zh-hant": "Chinees (traditioneel Han)", "hr": "Kroatisch", "hr-hr": "Kroatisch - Kroati\xEB", "cs": "Tsjechisch", "cs-cz": "Tsjechisch - Tsjechi\xEB", "da": "Deens", "da-dk": "Deens - Denemarken", "nl": "Nederlands", "nl-be": "Nederlands - Belgi\xEB", "nl-ch": "Nederlands - Zwitserland", "nl-lu": "Nederlands - Luxemburg", "nl-nl": "Nederlands - Nederland", "en": "Engels", "en-ae": "Engels - Verenigde Arabische Emiraten", "en-au": "Engels - Australi\xEB", "en-be": "Engels - Belgi\xEB", "en-ca": "Engels - Canada", "en-ch": "Engels - Zwitserland", "en-cn": "Engels - China", "en-de": "Engels - Duitsland", "en-ee": "Engels - Estland", "en-es": "Engels - Spanje", "en-fr": "Engels - Frankrijk", "en-hk": "Engels - Hongkong", "en-in": "Engels - India", "en-ie": "Engels - Ierland", "en-ke": "Engels - Kenia", "en-lu": "Engels - Luxemburg", "en-my": "Engels - Maleisi\xEB", "en-mt": "Engels - Malta", "en-mx": "Engels - Mexico", "en-nl": "Engels - Nederland", "en-nz": "Engels - Nieuw-Zeeland", "en-ph": "Engels - Filipijnen", "en-pk": "Engels - Pakistan", "en-se": "Engels - Zweden", "en-sg": "Engels - Singapore", "en-tn": "Engels - Tunesi\xEB", "en-za": "Engels - Zuid-Afrika", "en-gb": "Engels - Verenigd Koninkrijk", "en-us": "Engels - Verenigde Staten", "en-zw": "Engels - Zimbabwe", "et": "Ests", "et-ee": "Ests - Estland", "fo": "Faer\xF6ers", "fa": "Farsi", "fi": "Fins", "fi-fi": "Fins - Finland", "fil": "Filipijns", "fr": "Frans", "fr-be": "Frans - Belgi\xEB", "fr-ca": "Frans - Canada", "fr-fr": "Frans - Frankrijk", "fr-lu": "Frans - Luxemburg", "fr-mc": "Frans - Monaco", "fr-ch": "Frans - Zwitserland", "fr-tn": "Frans - Tunesi\xEB", "gl": "Galicisch", "ka": "Georgisch", "de": "Duits", "de-at": "Duits - Oostenrijk", "de-de": "Duits - Duitsland", "de-gr": "Duits - Griekenland", "de-li": "Duits - Liechtenstein", "de-lu": "Duits - Luxemburg", "de-ch": "Duits - Zwitserland", "el": "Grieks", "el-cy": "Grieks - Cyprus", "el-gr": "Grieks - Griekenland", "gu": "Gujarati", "haw": "Hawa\xEFaans", "ha": "Hausa", "he": "Hebreeuws", "he-il": "Hebreeuws - Isra\xEBl", "iw-il": "Hebreeuws - Isra\xEBl", "hi": "Hindi", "hi-in": "Hindi - India", "hu": "Hongaars", "hu-hu": "Hongaars - Hongarije", "is": "IJslands", "is-is": "IJslands - IJsland", "id": "Indonesisch", "in-id": "Indonesisch - Indonesi\xEB", "ga": "Iers", "ga-ie": "Iers - Ierland", "it": "Italiaans", "it-it": "Italiaans - Itali\xEB", "it-ch": "Italiaans - Zwitserland", "ja": "Japans", "ja-jp": "Japans - Japan", "kn": "Kannada", "kk": "Kazakh", "kok": "Konkani", "ko": "Koreaans", "ko-kr": "Koreaans - Zuid-Korea", "ku": "Koerdisch", "ky": "Kirgizisch", "ky-kg": "Kirgizisch", "lo": "Laotiaanse", "lv": "Lets", "lv-lv": "Lets - Letland", "lt": "Litouws", "lt-lt": "Litouws - Litouwen", "mk": "Macedonisch", "mk-mk": "Macedonisch - Macedoni\xEB", "ml": "Malayalam", "ms": "Maleis", "ms-bn": "Maleis - Brunei", "ms-my": "Maleis - Maleisi\xEB", "mt": "Maltees", "mt-mt": "Maltees - Malta", "mr": "Marathi", "mn": "Mongools", "my": "Birmaans", "my-mm": "Birmaans - Myanmar (Birma)", "ne": "Nepalees", "no": "Noors", "nb": "Noors Bokm\xE5l", "nb-no": "Noorse Bokmal - Noorwegen", "no-no": "Noors - Noorwegen", "pl": "Pools", "pl-pl": "Pools - Polen", "pt": "Portugees", "pt-br": "Portugees - Brazili\xEB", "pt-pt": "Portugees - Portugal", "pa": "Punjabi", "pa-in": "Punjabi-India", "pa-pk": "Punjabi-Pakistan", "ro": "Roemeens", "ro-ro": "Roemeens - Roemeni\xEB", "ru": "Russisch", "ru-ru": "Russisch - Rusland", "rw-rw": "Kinyarwanda", "sa": "Sanskriet", "si": "Singalees", "sr": "Servisch", "sr-ba": "Servisch - Bosni\xEB-Herzegovina", "sr-me": "Servisch - Montenegro", "sr-rs": "Servisch - Servi\xEB", "sr-cs": "Servisch - Servi\xEB en Montenegro (voormalig)", "sk": "Slowaaks", "sk-sk": "Slowaaks - Slowakije", "sl": "Sloveens", "sl-si": "Sloveens - Sloveni\xEB", "es": "Spaans", "es-ar": "Spaans - Argentini\xEB", "es-bo": "Spaans - Bolivia", "es-cl": "Spaans - Chili", "es-co": "Spaans - Colombia", "es-cr": "Spaans - Costa Rica", "es-cu": "Spaans - Cuba", "es-do": "Spaans - Dominicaanse Republiek", "es-ec": "Spaans - Ecuador", "es-sv": "Spaans - El Salvador", "es-gt": "Spaans - Guatemala", "es-hn": "Spaans - Honduras", "es-mx": "Spaans - Mexico", "es-ni": "Spaans - Nicaragua", "es-pa": "Spaans - Panama", "es-py": "Spaans - Paraguay", "es-pe": "Spaans - Peru", "es-pr": "Spaans - Puerto Rico", "es-es": "Spaans - Spanje", "es-us": "Spaans - Verenigde Staten", "es-uy": "Spaans - Uruguay", "es-ve": "Spaans - Venezuela", "sw": "Swahili", "sv": "Zweeds", "sv-fi": "Zweeds - Finland", "sv-se": "Zweeds - Zweden", "sy": "Syrisch", "ta": "Tamil", "tt": "Tataars", "te": "Telugu", "th": "Thais", "th-th": "Thai - Thailand", "tl": "Tagalog", "tr": "Turks", "tr-tr": "Turks - Turkije", "uk": "Oekra\xEFens", "uk-ua": "Oekra\xEFens - Oekra\xEFne", "ur": "Urdu", "uz": "Oezbeekse", "vi": "Vietnamees", "vi-vn": "Vietnamees - Vietnam", "yi": "Jiddisch", "zu": "Zoeloes" } } } } };
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "SharedI18nStrings": {
    "af": "static-1.161",
    "ar-eg": "static-1.161",
    "ar-sa": "static-1.161",
    "ar": "static-1.161",
    "be": "static-1.161",
    "bg": "static-1.161",
    "bn": "static-1.161",
    "ca-es": "static-1.161",
    "ca": "static-1.161",
    "cs": "static-1.161",
    "da": "static-1.161",
    "de": "static-1.161",
    "el": "static-1.161",
    "en-gb": "static-1.161",
    "en": "static-1.161",
    "es-ar": "static-1.161",
    "es-es": "static-1.161",
    "es-mx": "static-1.161",
    "es": "static-1.161",
    "et": "static-1.161",
    "eu": "static-1.161",
    "fi": "static-1.161",
    "fr-ca": "static-1.161",
    "fr": "static-1.161",
    "gl": "static-1.161",
    "gu": "static-1.161",
    "he-il": "static-1.161",
    "he": "static-1.161",
    "hi": "static-1.161",
    "hr": "static-1.161",
    "hu": "static-1.161",
    "hy": "static-1.161",
    "id": "static-1.161",
    "is": "static-1.161",
    "it": "static-1.161",
    "ja": "static-1.161",
    "ka": "static-1.161",
    "kk": "static-1.161",
    "kn": "static-1.161",
    "ko": "static-1.161",
    "ky": "static-1.161",
    "lt": "static-1.161",
    "lv": "static-1.161",
    "mk": "static-1.161",
    "mn": "static-1.161",
    "mr": "static-1.161",
    "ms-my": "static-1.161",
    "ms": "static-1.161",
    "nl-be": "static-1.161",
    "nl-nl": "static-1.161",
    "nl": "static-1.161",
    "no": "static-1.161",
    "pl": "static-1.161",
    "pt-br": "static-1.161",
    "pt-pt": "static-1.161",
    "ro": "static-1.161",
    "ru": "static-1.161",
    "sk": "static-1.161",
    "sl": "static-1.161",
    "sq": "static-1.161",
    "sr": "static-1.161",
    "sv": "static-1.161",
    "sw": "static-1.161",
    "ta": "static-1.161",
    "te": "static-1.161",
    "th": "static-1.161",
    "tl": "static-1.161",
    "tr": "static-1.161",
    "uk": "static-1.161",
    "ur": "static-1.161",
    "vi": "static-1.161",
    "zh-cn": "static-1.161",
    "zh-hans": "static-1.161",
    "zh-hant": "static-1.161",
    "zh-hk": "static-1.161",
    "zh-tw": "static-1.161"
  }
};
  hns('I18n', result);

})();



(function() {
  var result = { translations: { "nl": { "i18n": { "duration": { "seconds": "{{ seconds }} sec", "minutes": "{{ minutes }} min", "hours": "{{ hours }} uur", "hoursAndMinutes": "{{ hours }} uur {{ minutes }} min", "days": "{{ days }} dagen", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}u", "days": "{{ days }}d", "hoursAndMinutes": "{{ hours }}u {{ minutes }}m" } }, "dateTime": { "quarterAndYear": "K{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, ext. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "nl": "static-7.1359"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1359",
    "ar-eg": "static-7.1359",
    "bg": "static-7.1359",
    "bn": "static-7.1359",
    "ca-es": "static-7.1359",
    "cs": "static-7.1359",
    "da": "static-7.1359",
    "de": "static-7.1359",
    "el": "static-7.1359",
    "en-gb": "static-7.1359",
    "en": "static-7.1359",
    "es-mx": "static-7.1359",
    "es": "static-7.1359",
    "et": "static-7.1359",
    "fi": "static-7.1359",
    "fr-ca": "static-7.1359",
    "fr": "static-7.1359",
    "he-il": "static-7.1359",
    "hi": "static-7.1359",
    "hr": "static-7.1359",
    "hu": "static-7.1359",
    "id": "static-7.1359",
    "it": "static-7.1359",
    "ja": "static-7.1359",
    "ko": "static-7.1359",
    "lt": "static-7.1359",
    "ms": "static-7.1359",
    "nl": "static-7.1359",
    "no": "static-7.1359",
    "pl": "static-7.1359",
    "pt-br": "static-7.1359",
    "pt-pt": "static-7.1359",
    "ro": "static-7.1359",
    "ru": "static-7.1359",
    "sk": "static-7.1359",
    "sl": "static-7.1359",
    "sv": "static-7.1359",
    "th": "static-7.1359",
    "tl": "static-7.1359",
    "tr": "static-7.1359",
    "uk": "static-7.1359",
    "vi": "static-7.1359",
    "x-pseudo": "static-7.1359",
    "zh-cn": "static-7.1359",
    "zh-hk": "static-7.1359",
    "zh-tw": "static-7.1359"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:nl', {version: 'static-7.1359'}); }
})();



(function() {
  var result = { translations: { "nl": { "videoPlayer": { "htmlTitle": "HubSpot-video", "htmlTitleWithVideo": "{{ videoTitle }} | HubSpot-video", "controls": { "audioPlayer": "Audiospeler", "videoPlayer": "Videospeler", "play": "Afspelen", "playVideo": "Video afspelen", "pause": "Pauzeren", "replay": "Opnieuw afspelen", "currentTime": "Huidige tijd", "duration": "Duur", "remainingTime": "Resterende tijd", "fullscreen": "Volledig scherm", "exitFullscreen": "Volledig scherm afsluiten", "mute": "Dempen", "unmute": "Dempen uitzetten", "volumeLevel": "Volumeniveau", "captions": "Bijschriften", "captionsOff": "Uit", "seekBar": "Positie aanpassen", "chapter": "Hoofdstuk", "elapsedTime": "Verstreken tijd: {{timeDisplay}}" }, "playbackOptions": { "buttonTitle": "Afspeelopties", "playbackRate": "Afspeelsnelheid:", "quality": "Kwaliteit:", "normal": "Normaal", "auto": "(Auto)" }, "formModal": { "defaultThankYouMessage": "Bedankt voor je reactie.", "inlineMessageButton": "Video bekijken" }, "ctaModal": { "imgAlt": "Video-CTA" }, "errors": { "generic": { "heading": "Kon video niet laden" }, "UNAUTHORIZED": { "heading": "Video niet ingeschakeld" }, "VIDEO_NOT_FOUND": { "heading": "Video niet gevonden" }, "INVALID_URL": { "heading": "Video niet gevonden" }, "UNSUPPORTED_EMBED": { "heading": "Video niet beschikbaar", "extra": "Deze video kan niet extern worden weergegeven." }, "refreshLink": "Opnieuw proberen" } } } } };
  result.translationsLoaded = {
  "video-player-ui": {
    "nl": "static-1.29208"
  }
};
  result.translationsAvailable = {
  "video-player-ui": {
    "af": "static-1.29208",
    "ar-eg": "static-1.29208",
    "bg": "static-1.29208",
    "bn": "static-1.29208",
    "ca-es": "static-1.29208",
    "cs": "static-1.29208",
    "da": "static-1.29208",
    "de": "static-1.29208",
    "el": "static-1.29208",
    "en-gb": "static-1.29208",
    "en": "static-1.29208",
    "es-mx": "static-1.29208",
    "es": "static-1.29208",
    "et": "static-1.29208",
    "fi": "static-1.29208",
    "fr-ca": "static-1.29208",
    "fr": "static-1.29208",
    "he-il": "static-1.29208",
    "hi": "static-1.29208",
    "hr": "static-1.29208",
    "hu": "static-1.29208",
    "id": "static-1.29208",
    "it": "static-1.29208",
    "ja": "static-1.29208",
    "ko": "static-1.29208",
    "lt": "static-1.29208",
    "ms": "static-1.29208",
    "nl": "static-1.29208",
    "no": "static-1.29208",
    "pl": "static-1.29208",
    "pt-br": "static-1.29208",
    "pt-pt": "static-1.29208",
    "ro": "static-1.29208",
    "ru": "static-1.29208",
    "sk": "static-1.29208",
    "sl": "static-1.29208",
    "sv": "static-1.29208",
    "th": "static-1.29208",
    "tl": "static-1.29208",
    "tr": "static-1.29208",
    "uk": "static-1.29208",
    "vi": "static-1.29208",
    "zh-cn": "static-1.29208",
    "zh-hk": "static-1.29208",
    "zh-tw": "static-1.29208"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:video-player-ui:nl', {version: 'static-1.29208'}); }
})();


